import { render, staticRenderFns } from "./IconoEstadoActivo.vue?vue&type=template&id=2e08224c&"
import script from "./IconoEstadoActivo.vue?vue&type=script&lang=js&"
export * from "./IconoEstadoActivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports